
import React from 'react';
import Hero from '@/components/Hero';
import Benefits from '@/components/Benefits';
import Products from '@/components/Products';
import Process from '@/components/Process';
import Portfolio from '@/components/Portfolio';
import Reviews from '@/components/Reviews';
import Contact from '@/components/Contact';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';

const Index = () => {
  return (
    <main className="min-h-screen bg-white">
      <Hero />
      <Products />
      <Benefits />
      
      <section id="about" className="py-16 bg-honey-50">
        <div className="container mx-auto px-4">
          <h2 className="font-cormorant-garamond text-4xl font-bold text-center mb-16">О нас</h2>
          
          <div className="max-w-4xl mx-auto space-y-12">
            <Card className="bg-white/80 backdrop-blur">
              <CardContent className="p-8">
                <h3 className="font-cormorant-garamond text-2xl font-semibold mb-6">История бренда</h3>
                <div className="space-y-4 text-gray-700">
                  <p>Бренд Budnik Bee Garden был создан из любви к природе и красоте.</p>
                  <p>Бренд Budnik Bee Garden это семейное наследие, летопись которого продолжается биением любящих сердец семьи Будник.</p>
                  <p>Некоторые из моих самых теплых детских воспоминаний связаны с тем, как я проводила лето на пчелином участке моей семьи.</p>
                  <p>Мы с семьей проводили там много времени, играли в настольные игры и устраивали пикники, ухаживали за невероятной красоты садом, помогали старшему поколению заботиться о пчелах.</p>
                  <p>Удивительным переплетением судеб оказалось, что в детстве у семьи супруга тоже была пасека, и это было одним из самых теплых и прекрасных воспоминаний из его детства.</p>
                  <p>Было решено возродить традицию пчеловодства, перенять опыт у старшего поколения семьи, с тем, чтобы заботиться о медоносных пчелах так же, как это всегда делали предшествующие поколения семьи, ставя благополучие пчел на первое место во всем, что мы делаем.</p>
                </div>
                
                <div className="bg-honey-100 p-6 rounded-lg my-8">
                  <h4 className="font-semibold mb-2">Знаете ли вы?</h4>
                  <p>Медоносные пчелы — самые важные опылители в мире, что делает их основоположниками здоровья нашей природной экосистемы.</p>
                </div>
                
                <p className="text-gray-700">Присоединяйтесь к нам в нашем путешествии к более устойчивому будущему, где красота и ответственность расцветают вместе.</p>
                
                <div className="mt-8 text-center">
                  <Link to="/about" className="inline-block bg-honey-500 hover:bg-honey-600 text-black px-6 py-3 rounded-full text-sm font-medium transition-all">
                    Узнать больше о нас
                  </Link>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
      
      <Process />
      <Portfolio />
      <section className="py-16 bg-honey-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="font-cormorant-garamond text-4xl font-bold mb-8">Музыка</h2>
          <p className="text-gray-700 mb-8 max-w-2xl mx-auto">
            Насладитесь атмосферной музыкой, которая идеально дополнит ваш отдых с нашими свечами
          </p>
          <Link to="/music" className="inline-block bg-honey-500 hover:bg-honey-600 text-black px-6 py-3 rounded-full font-medium transition-all">
            Слушать музыку
          </Link>
        </div>
      </section>
      <Reviews />
      <Contact />
    </main>
  );
};

export default Index;
